import * as React from "react";
import "./App.css";
import logo from "./love.png";
import FormComponent from "./FormComponent";

import { Avatar } from "@mui/material";
import { red } from "@mui/material/colors";
import ReactPlayer from "react-player";

const moodData = {
  sad: {
    emoji: "🥲",
    quote: "Don't feel sad — I'm here for you.",
    videoSrc: "https://youtu.be/H1frBzuWqqM?si=5tw0ygW-jD-oHPWc",
  },
  evil: {
    emoji: "👿",
    quote: "Sometimes you gotta be bad to do good.",
    videoSrc: "https://youtu.be/nuKXEb-K24Q?si=W_V_8nYJhaKQeYdg",
  },
  annoyed: {
    emoji: "😒",
    quote: "Lost your patience? Let's go on a date!",
    videoSrc: "https://youtu.be/P-jKtzUuVcM?si=SeyUAYbXx9Z-diDo",
  },
  happy: {
    emoji: "🥰",
    quote: "I hope you're the happiest person in the world.",
    videoSrc: "https://youtu.be/rxp_zOtY-IA?si=oii68MGUV1EnDzk7",
  },
  love: {
    emoji: "😘",
    quote: "I miss you... 😍",
    videoSrc: "https://youtu.be/U1JLtpJTe84?si=oVWM4-9i-3ZJlZ_7",
  },
  angry: {
    emoji: "😡",
    quote: "Why are you feeling angry?",
    videoSrc: "https://youtu.be/ckwRhLE9_LY?si=MCAAgDybBMH8jMfE",
  },
};

const emojiToMoodKey = {
  "🥲": "sad",
  "👿": "evil",
  "😒": "annoyed",
  "🥰": "happy",
  "😘": "love",
  "😡": "angry",
};

const avatars = Object.keys(emojiToMoodKey);

export default function App() {
  const [selectedMood, setSelectedMood] = React.useState("happy");

  const handleAvatarClick = (emoji) => {
    const moodKey = emojiToMoodKey[emoji];
    if (moodKey) {
      setSelectedMood(moodKey);
    }
  };

  const mood = moodData[selectedMood];

  const isYouTube = mood.videoSrc.includes("youtube.com");

  return (
    <div className="App">
      <header className="App-header">
        <p>Hi Baby 💖</p>
        <img src={logo} className="App-logo" alt="logo" />
        <p>My love, what's bothering you?</p>
        <a
          className="App-link"
          href="https://www.youtube.com/watch?v=H1frBzuWqqM"
          target="_blank"
          rel="noopener noreferrer"
        >
          My heart speaks — listen 🎧
        </a>
      </header>

      <h4 style={{ fontSize: 20, marginBottom: 0 }}>Tell me Your mood 👻</h4>
      <div
        className="avatar-container no-scrollbar"
        style={{
          display: "flex",
          overflowX: "auto",
          gap: 12,
          padding: "1rem 1.5rem",
        }}
      >
        {avatars.map((emoji, index) => (
          <div key={index} style={{ scrollSnapAlign: "start", flexShrink: 0 }}>
            <Avatar
              sx={{
                bgcolor: red[500],
                width: 70,
                height: 70,
                fontSize: "2rem",
                cursor: "pointer",
                border:
                  emojiToMoodKey[emoji] === selectedMood
                    ? "3px solid deeppink"
                    : "none",
                transition: "border 0.3s",
              }}
              onClick={() => handleAvatarClick(emoji)}
              aria-label={`Select mood ${emoji}`}
            >
              {emoji}
            </Avatar>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: 20,
          maxWidth: 800,
          width:"95%",
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontWeight: "bold", fontSize: 18, color: "deeppink" }}>
          {mood.emoji} {mood.quote}
        </h2>

        <div
          style={{
            position: "relative",
            paddingTop: "56.25%",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            marginTop: 10,
          }}
        >
          <ReactPlayer
            url={mood.videoSrc}
            playing
            muted
            loop
            controls
            width="100%"
            height="100%"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
          />
        </div>
      </div>

      <div style={{ padding: "0rem" }}>
        <h1>Submit a grievance 🥀</h1>
        <FormComponent />
      </div>
    </div>
  );
}
